import React from 'react';
import {CircularProgress, CircularProgressProps} from '@material-ui/core';
import './LoaderStyles.scss';

const Loader = (props: CircularProgressProps): React.ReactElement => {
  return <CircularProgress {...props} />;
};
export default Loader;
